<template>
  <div class="content-news">
    <div class="grid-container">
      <div class="inner">
        <div class="titlewrapper">
          <h2 v-if="data.title" class="title" v-html="data.title" />
          <StructuredText v-if="data.lead" class="structured-text lead" :data="data.lead" />
        </div>
        <div class="newsteaser-wrapper">
          <NewsTeaser v-for="it in data.news" :key="it.id" :data="it" />
          <div class="pattern" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { StructuredText } from 'vue-datocms';
import type { ContentNewsFragment } from '#gql';
import NewsTeaser from '~/components/content-modules/components/NewsTeaser.vue';

defineProps<{
  data: ContentNewsFragment;
}>();
</script>

<style scoped lang="scss">
.content-news {
  background-color: var(--color-forest-light);
  color: var(--color-forest-dark);
  width: 100%;
  position: relative;

  @media (--xs), (--sm) {
    padding: var(--spacing-4xl) 0;
  }

  @media (--md), (--lg) {
    padding: var(--spacing-5xl) 0 calc(var(--spacing-5xl) + 3rem); // 3rem from offset pattern
  }

  > .grid-container {
    @include grid-layout();

    & {
      padding: var(--site-inner-padding);
      width: 100%;
      max-width: var(--site-max-width);
      margin: auto;
    }

    > .inner {
      display: grid;
      grid-template-columns: subgrid;

      @media (--xs) {
        grid-column: 1 / -1;
      }

      @media (--sm), (--md), (--lg) {
        grid-column: 2 / 24;
      }

      > .titlewrapper {
        display: grid;
        gap: var(--spacing-2xs);

        @media (--xs), (--sm) {
          padding-bottom: var(--spacing-sm);
          grid-column: 1 / -1;
        }

        @media (--md), (--lg) {
          grid-column: 4 / 20;
          padding-bottom: var(--spacing-2xl);
        }

        > .title {
          color: var(--color-forest-dark);
        }
      }

      > .newsteaser-wrapper {
        display: grid;
        gap: var(--spacing-xs);
        position: relative;
        z-index: 1;
        grid-column: 1 / -1;

        @media (--md), (--lg) {
          grid-template-columns: repeat(2, 1fr);
        }

        @media (--lg-custom) {
          grid-template-columns: repeat(3, 1fr);
        }

        > .pattern {
          position: absolute;
          z-index: -1;
          background: url('/design-elements/pattern.svg');
          width: 100%;
          height: 100%;

          @media (--xs), (--sm) {
            bottom: -1.5rem;
            right: -1.5rem;
          }

          @media (--md), (--lg) {
            bottom: -3rem;
            right: -3rem;
          }
        }
      }
    }
  }
}
</style>
